export default "__VITE_ASSET__c427b139__"